import { render, staticRenderFns } from "./DiscoverCrop.vue?vue&type=template&id=38c403c5&"
import script from "./DiscoverCrop.vue?vue&type=script&lang=js&"
export * from "./DiscoverCrop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports